module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/update-5e7d8307855295dc3d309a4922401c8e.svg";